import { Action } from 'redux';

import ActionFetchMapFieldListSuccess from '../interfaces/actions/ActionFetchMapFieldListSuccess';
import ActionPayloadArrayOfNumber from '../interfaces/actions/ActionPayloadArrayOfNumber';
import ActionSetCurrentDrawLayer from '../interfaces/actions/ActionSetCurrentDrawLayer';

import * as Const from '../constants';

export const setMapFieldListInit = (): Action => {
  return {
    type: Const.FETCH_MAP_FIELD_LIST_INIT,
  };
};

export const setMapFieldListPending = (): Action => {
  return {
    type: Const.FETCH_MAP_FIELD_LIST_PENDING,
  };
};

export const fetchMapFieldListSuccess = (payload: any): ActionFetchMapFieldListSuccess => {
  return {
    type: Const.FETCH_MAP_FIELD_LIST_SUCCESS,
    payload,
  };
};

export const fetchMapFieldListOrder = (payload: number[]): ActionPayloadArrayOfNumber => {
  return {
    type: Const.FETCH_MAP_FIELD_LIST_ORDER,
    payload,
  };
};

export const setMapFieldListError = (): Action => {
  return {
    type: Const.FETCH_MAP_FIELD_LIST_ERROR,
  };
};

export const setCurrentDrawLayer = (payload: number[][]): ActionSetCurrentDrawLayer => {
  return {
    type: Const.SET_CURRENT_DRAW_LAYER,
    payload,
  };
};

export const setCurrentCenter = (payload: number[]): ActionPayloadArrayOfNumber => {
  return {
    type: Const.SET_CURRENT_CENTER,
    payload,
  };
};
